import useSocialMediaEditForm from "./UseSocialMediaEditForm";

import Input from "@usas/ui-web/components/inputs/Input";
import ReadOnly from "@usas/ui-web/components/readOnly/ReadOnly";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SocialMediaEditForm = ({ socialMediaObj, submitButtonText = 'Save', secondaryButtonText = 'Cancel',
  onSubmitFormCallback, onSecondaryButtonClicked, onIsDirtyChanged = undefined, onErrorCaught = undefined }) => {
  const {
    isDirty,
    formState,
    errorState,
    handleSubmit,
    updateFormState
  } = useSocialMediaEditForm(socialMediaObj, onSubmitFormCallback, onIsDirtyChanged, onErrorCaught);

  return (
    <form onSubmit={handleSubmit} noValidate>
      <div className="row">
        <div className="col-xs-12 col-sm-6">
          <ReadOnly
            label="Social Media Platform"
            name="socialMediaTypeId"
            value={socialMediaObj.socialMediaType?.typeName} />
        </div>
      </div>
      <div className="row">
        <div className='col-xs-12 col-sm-6'>
          <Input
            label="Handle / Username / Website"
            name="socialHandle"
            value={formState.socialHandle}
            error={errorState.socialHandle}
            message={errorState.socialHandle}
            onChange={(value) => { updateFormState('socialHandle', value); }} />
        </div>
      </div>
      {errorState.errorOnSubmitAction &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction || ''}</p>
          </div>
        </div>
      }
      {errorState.formError &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{errorState.formError || ''}</p>
          </div>
        </div>
      }
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <PrimaryButton type="submit" isDisabled={isDirty === false}>{submitButtonText}</PrimaryButton>&nbsp;
          <SecondaryButton type='button' onClick={onSecondaryButtonClicked}>{secondaryButtonText}</SecondaryButton>
        </div>
      </div>
    </form>
  );
};

export default SocialMediaEditForm;